import { useState } from 'react';

import type { HousekeepingRoomStatus } from '../../../pages/housekeeping/types/housekeeping';
import { useRefuserControle } from '../../api/useControles';
import BottomSheet from '../../components/BottomSheet';
import Button from '../../components/Button';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';
import ChampTexte from '../menage/ChampTexte';

/**
 * Refuser un contrôle : motif obligatoire (il devient une note visible par la femme
 * de chambre), la chambre repasse « Libre sale » chez la même personne. La
 * réaffectation reste au web.
 */
interface FeuilleRefusProps {
    chambre: HousekeepingRoomStatus;
    onFermer: () => void;
    onRefusee: () => void;
}

export default function FeuilleRefus({ chambre, onFermer, onRefusee }: FeuilleRefusProps) {
    const refuser = useRefuserControle();
    const [motif, setMotif] = useState('');
    const [echec, setEchec] = useState<string | null>(null);

    const confirmer = () => {
        setEchec(null);
        refuser.mutate(
            { serviceId: chambre.service_id, reason: motif.trim() },
            {
                onSuccess: onRefusee,
                onError: (err) =>
                    setEchec(err?.response?.data?.message || t('controles.refus.echec')),
            },
        );
    };

    return (
        <BottomSheet ouverte onClose={onFermer} libelle={t('controles.refus.titreFeuille', { chambre: chambre.room_name })} libelleFermeture={t('commun.fermer')}>
            <div className="flex flex-col gap-4">
                <Text variante="titre" as="h2">
                    {t('controles.refus.titre', { chambre: chambre.room_name })}
                </Text>
                <ChampTexte libelle={t('controles.refus.motif')} valeur={motif} onChange={setMotif} />
                {echec && (
                    <div role="alert">
                        <Text variante="petit" ton="danger">
                            {echec}
                        </Text>
                    </div>
                )}
                <Button
                    libelle={t('controles.refus.confirmer')}
                    variante="danger"
                    pleineLargeur
                    disabled={motif.trim() === '' || refuser.isLoading}
                    onPress={confirmer}
                />
            </div>
        </BottomSheet>
    );
}
